// extracted by mini-css-extract-plugin
export default {"forgotPassword":"ForgotPassword_forgotPassword__6cR3i"};